import $ from 'jquery';

class ClipboardController {
    static fallbackCopyTextToClipboard(button, inputObject, successText) {
        const inputArea = document.getElementById(inputObject);
        inputArea.focus();
        inputArea.select();

        try {
            document.execCommand('copy');
            $(button).text(successText);
        }
        catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }
    }

    // async method
    static copyTextToClipboard(button, inputObject, successText) {
        if (!navigator.clipboard) {
            ClipboardController.fallbackCopyTextToClipboard(button, inputObject, successText);
            return;
        }

        const text = $(`#${inputObject}`).val();
        navigator.clipboard.writeText(text).then(() => {
            $(button).text(successText);
        }, (err) => {
            console.error('Async: Could not copy text: ', err);
        });
    }
}

window.ClipboardController = ClipboardController;
export default ClipboardController;
